module.exports = __webpack_public_path__ + "img/realisationSadp.2feca13f.jpg";